import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminCenterTransfer(props) {
    const formcenterRef = useRef(null)
    const server_chao_urlRef = useRef(null)
    const server_cpf_countryRef = useRef(null)
    const server_cpf_plantRef = useRef(null)
    const server_cpf_plant_idRef = useRef(null)
    const server_cpf_areaRef = useRef(null)
    const server_cpf_machine_typeRef = useRef(null)

    const [centertransferitem, setCentertransferitem] = useState({
        server_chao_enable: false,
        server_chao_url: '',
        server_cpf_enable: false,
        server_cpf_country: '',
        server_cpf_plant: '',
        server_cpf_plant_id: '',
        server_cpf_area: '',
        server_cpf_machine_type: '',
        edittime: ''
    });
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        if (centertransferitem.server_chao_enable === false) {
            server_chao_urlRef.current.disabled = true
        } else {
            server_chao_urlRef.current.disabled = false
        }
    }, [centertransferitem.server_chao_enable]);

    useEffect(() => {
        if (centertransferitem.server_cpf_enable === false) {
            server_cpf_countryRef.current.disabled = true
            server_cpf_plantRef.current.disabled = true
            server_cpf_plant_idRef.current.disabled = true
            server_cpf_machine_typeRef.current.disabled = true
            server_cpf_areaRef.current.disabled = true
        } else {
            server_cpf_countryRef.current.disabled = false
            server_cpf_plantRef.current.disabled = false
            server_cpf_plant_idRef.current.disabled = false
            server_cpf_machine_typeRef.current.disabled = false
            server_cpf_areaRef.current.disabled = false
        }
    }, [centertransferitem.server_cpf_enable]);

    useEffect(() => {
        api_get_list()
        return () => {
            setCentertransferitem({});
        }
    }, []);

    async function api_get_list() {
        setmodal_load({ enable: true, message: "Loading center transfer." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/centertransfer/getdata", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setCentertransferitem(response.data.centertransfer)
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_save_data() {
        var formelement = formcenterRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            setmodal_load({ enable: true, message: "Saving center transfer." })
            await sleep(500)

            formelement.classList.remove("was-validated");
            const formData = new FormData();
            formData.append('server_chao_enable', centertransferitem.server_chao_enable)
            formData.append('server_chao_url', centertransferitem.server_chao_url)
            formData.append('server_cpf_enable', centertransferitem.server_cpf_enable)
            formData.append('server_cpf_country', centertransferitem.server_cpf_country)
            formData.append('server_cpf_plant', centertransferitem.server_cpf_plant)
            formData.append('server_cpf_plant_id', centertransferitem.server_cpf_plant_id)
            formData.append('server_cpf_area', centertransferitem.server_cpf_area)
            formData.append('server_cpf_machine_type', centertransferitem.server_cpf_machine_type)

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/centertransfer/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your center transfer has been saved to database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        })
                    }
                    if (response.data.centertransfer !== undefined) {
                        setCentertransferitem(response.data.centertransfer)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    })
                });
        }
    }

    async function api_reboot() {
        setmodal_load({ enable: true, message: "Rebooting application....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/app/reboot", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your application has been recieved reboot command.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-network-wired"></i> Center Transfer</h4>
                                    <p className="mb-3">Manage all center transfer</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" type="button" onClick={() => { api_get_list() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_reboot() }}><i className="fas fa-power-off"></i> Reboot Service</button>
                            </div>
                        </div>
                    </div>

                    <form ref={formcenterRef} className='mt-3 mb-1 mb-md-4' action="" method="POST" encType="multipart/form-data" >
                        <div className="row">
                            <h6>CHOW Energy Solar HTTP Server Connection</h6>
                            <div className="col-xl-6">
                                <div className="form-check mb-3">
                                    <input name="server_chao_enable" className="form-check-input" type="checkbox" checked={centertransferitem.server_chao_enable} onChange={(e) => {
                                        setCentertransferitem({
                                            ...centertransferitem,
                                            server_chao_enable: e.target.checked
                                        })
                                    }} disabled />
                                    <label htmlFor="server_chao_enable" className="form-check-label">
                                        Enable Post Data to CHOW Energy Center Web App.
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="server_chao_url">Server CHOW URL</label>
                                    <input type="text" className="form-control" ref={server_chao_urlRef} name="server_chao_url" value={centertransferitem.server_chao_url} onChange={(e) => {
                                        setCentertransferitem({
                                            ...centertransferitem,
                                            server_chao_url: e.target.value
                                        })
                                    }} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <h6>CPF MQTT Server Connection</h6>
                            <div className="col-md-6">
                                <div className="form-check mb-3">
                                    <input name="server_cpf_enable" className="form-check-input" type="checkbox" checked={centertransferitem.server_cpf_enable} onChange={(e) => {
                                        setCentertransferitem({
                                            ...centertransferitem,
                                            server_cpf_enable: e.target.checked
                                        })
                                    }} disabled />
                                    <label htmlFor="server_cpf_enable" className="form-check-label">
                                        Enable Post Data to CPF MQTT Server.
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="server_cpf_country">MQTT Country</label>
                                    <input type="text" className="form-control" ref={server_cpf_countryRef} name="server_cpf_country" value={centertransferitem.server_cpf_country} onChange={(e) => {
                                        setCentertransferitem({
                                            ...centertransferitem,
                                            server_cpf_country: e.target.value
                                        })
                                    }} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="server_cpf_plant">MQTT Plant Code</label>
                                    <input type="text" className="form-control" ref={server_cpf_plantRef} name="server_cpf_plant" value={centertransferitem.server_cpf_plant} onChange={(e) => {
                                        setCentertransferitem({
                                            ...centertransferitem,
                                            server_cpf_plant: e.target.value
                                        })
                                    }} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="server_cpf_plant_id">MQTT Plant ID</label>
                                    <input type="text" className="form-control" ref={server_cpf_plant_idRef} name="server_cpf_plant_id" value={centertransferitem.server_cpf_plant_id} onChange={(e) => {
                                        setCentertransferitem({
                                            ...centertransferitem,
                                            server_cpf_plant_id: e.target.value
                                        })
                                    }} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="server_cpf_machine_type">MQTT Machine Type</label>
                                    <input type="text" className="form-control" ref={server_cpf_machine_typeRef} name="server_cpf_machine_type" value={centertransferitem.server_cpf_machine_type} onChange={(e) => {
                                        setCentertransferitem({
                                            ...centertransferitem,
                                            server_cpf_machine_type: e.target.value
                                        })
                                    }} required readOnly />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="server_cpf_area">MQTT Area</label>
                                    <input type="text" className="form-control" ref={server_cpf_areaRef} name="server_cpf_area" value={centertransferitem.server_cpf_area} onChange={(e) => {
                                        setCentertransferitem({
                                            ...centertransferitem,
                                            server_cpf_area: e.target.value
                                        })
                                    }} required readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="edittime">Edit Time</label>
                                    <input type="text" className="form-control" name="edittime" value={centertransferitem.edittime} readOnly />
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-md-3 mb-1 mt-3">
                            <button className="btn btn-warning btn-sm" type="button" onClick={() => { api_save_data() }} disabled><i className="fe-save"></i> Save</button>
                        </div>
                    </div>
                    <hr className="new-section-xs" />
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminCenterTransfer